import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../Api/Api";
import Select from "../../../Common/FormElements/Select/Select";

const TransporterSelector = ({
  orders,
  currentTransporter,
  setCurrentTransporter,
}) => {
  const [transporters, setTransporters] = useState([]);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation("common");

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const { data } = await API.get("/api/transporters");

        setTransporters(data?.data);
        const { data: currentTransporter } = await API.get(
          `/api/transporters`,
          {
            params: {
              filters: {
                deliveries: {
                  commande: {
                    id: {
                      $in: orders || [],
                    },
                  },
                },
              },
            },
          }
        );

        setCurrentTransporter(currentTransporter?.data?.[0]);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [setCurrentTransporter]);

  return (
    <div className="d-flex w-100 align-items-center justify-content-between gap-5 py-2">
      <label className="f16 text-dark mb-2">{t("Transporters")}</label>
      <Select
        appendToSelf
        filter
        options={transporters?.map((item) => ({
          name: item?.attributes?.name,
          code: item?.id,
        }))}
        value={
          currentTransporter
            ? {
                name: currentTransporter?.attributes?.name,
                code: currentTransporter?.id,
              }
            : null
        }
        panelClassName="bottom-50px top-unset"
        className="flex-grow-1 max-w-350px"
        placeholder={loading ? t("Loading...") : t("Select")}
        disabled={loading}
        callback={(e) => {
          setCurrentTransporter(
            transporters?.find((item) => +item.id === +e.value.code)
          );
        }}
      />
    </div>
  );
};

export default TransporterSelector;
